import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import './PostPage.css';

const PostPage = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await api.getPost(slug);
                setPost(response.data);
            } catch (err) {
                setError('Failed to load post');
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [slug]);

    if (loading) return <div className="post-page">Loading...</div>;
    if (error) return <div className="post-page error">{error}</div>;
    if (!post) return <div className="post-page">Post not found</div>;

    return (
        <div className="post-page">
            <header className="post-page-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <article className="post-article">
                <header className="post-article-header">
                    <h2 className="post-article-title">{post.title}</h2>
                    <time className="post-article-date">
                        {new Date(post.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}
                    </time>
                </header>

                <div className="post-article-content">
                    {post.content.split('\n\n').map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>

                <footer className="post-article-footer">
                    <Link to="/blog" className="back-link">← Back to Essays</Link>
                </footer>
            </article>
        </div>
    );
};

export default PostPage;
